export enum SaleStatus {
	Available = 0,
	NonBindingOralReservation = 100,
	BindingOralReservation = 101,
	ReservationAgreement = 200,
	ReservationContract = 400,
	SaleContract = 500,
	Sold = 600
}
